import { render, staticRenderFns } from "./infoUpDown.vue?vue&type=template&id=67e54623&"
import script from "./infoUpDown.vue?vue&type=script&lang=js&"
export * from "./infoUpDown.vue?vue&type=script&lang=js&"
import style0 from "./infoUpDown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports